import {
  mapActions
} from 'vuex'
import { saveColumnChecked, getColumnChecked } from '@/assets/js/localStorage'
import _ from 'lodash'
export default {
  data() {
    return {
      tableData: [],
      tableEncryption:false,
      dataListSelections: [],
      toExcel: false,
      dateTimePickerOptions: {
        disabledDate(time) {
          return  time.getTime() > Date.now();
        }
      },
      options: {
        mutiSelect: true,
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        calculateHeight: true, //是否自适应高度
        height: null, //高度
        selection: [],
        highlightCurrentRow: false,
        curRow: {},
      },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20
      },
      deptTreeData:[]
    }
  },
  methods: {
    ...mapActions([
      'alertToggle',
      'fetchData'
    ]),
    /**
     * 列表分页
     */
    handlePageChange(val, opt) {
      if(this.privatePagination){
        this.privatePagination.pageIndex = val;
        this.privatePagination.pageSize = opt;
      }else{
        this.pagination.pageIndex = val;
        this.pagination.pageSize = opt;
      }
      this.getQuery()
    },
    /**
     * 列表查询
     */
    getDataList(reset=true) {
      if(this.privatePagination){
        this.privatePagination.pageIndex = 1;
      }else{
        this.pagination.pageIndex = 1;
      }
      this.filters && (this.filters.page = 1);
      reset && this.resetFilter()
      this.getQuery()
    },
    resetFilter() {
      if (!this.filters) return

      if(this.filtersInitSearchData){
        this.filters.search = {...this.filtersInitSearchData}
        return
      }

      for (let name in this.filters.search) {
        if(name.substring(0,12)!='selLabelType'){
          this.filters.search[name] = ''
        }
      }
    },
    handleSearch() {
      if(this.privatePagination){
        this.privatePagination.pageIndex = 1;
      }else{
        this.pagination.pageIndex = 1;
      }
      this.filters && (this.filters.page = 1);
      this.getQuery()
    },

    //获取当前门店信息
    getCurStoreInfo(){
      let curShopInfo = {}
      let localShop = localStorage.getItem("curShop")
      if(localShop && localShop!==undefined && localShop!=='undefined' && typeof localShop==='string' ){
        curShopInfo = JSON.parse(localShop)
      }
      return curShopInfo
    },

    //获取查询参数
    /**
     * 获取查询参数
     */
    getQueryParams() {
      if (!this.filters) return {}

      let searches = {}
      for (let name in this.filters.search) {
        if (this.filters.search[name] === '' ) {
          continue;
        }
        let searchParam = this.filters.search[name]
        searches[name] = typeof searchParam === 'string' ? searchParam.trim() : searchParam
      }
      if(this.toExcel==true ){
        if(this.options.selection.length){
          let ids = this.getProValues(this.options.selection)
          searches['ids'] = ids.join(',')
        }

        let cols = []
        if(this.tableVarity && this.tableColumn){
          this.tableColumn.map((item)=>{
            item.visible && cols.push(item.property || item.prop)
          })
        }
        searches['exportFiled'] = cols.join(',')
      }
      if(this.privatePagination){
        return {
          ...searches,
          start: (this.privatePagination.pageIndex - 1) * this.privatePagination.pageSize,
          size: this.filters.pageSize,
        }
      }else{
        return {
          ...searches,
          start: (this.pagination.pageIndex - 1) * this.pagination.pageSize,
          size: this.filters.pageSize,
        }
      }
    },
    
    /**
     * 获取查询参数V2.0
     */
     getQueryListParams() {
      if (!this.filters) return {}

      let searches = {}
      for (let name in this.filters.search) {
        if (this.filters.search[name] === '' ) {
          continue;
        }
        let searchParam = this.filters.search[name]
        searches[name] = typeof searchParam === 'string' ? searchParam.trim() : searchParam
      }
      if(this.toExcel==true ){
        if(this.options.selection.length){
          let ids = this.getProValues(this.options.selection)
          searches['ids'] = ids.join(',')
        }

        let cols = []
        if(this.tableVarity && this.tableColumn){
          this.tableColumn.map((item)=>{
            item.visible && cols.push(item.property || item.prop)
          })
        }
        searches['exportFiled'] = cols.join(',')
      }
      if(this.privatePagination){
        return {
          ...searches,
          pageNumber: this.privatePagination.pageIndex,
          pageSize: this.privatePagination.pageSize,
        }
      }else{
        return {
          ...searches,
          pageNumber: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
        }
      }
    },
    /**
     * 获取查询参数,返回值包含params
     */
    getQueryParams2(){
      if (!this.filters) return {}

      let searches = {}
      for(let name in this.filters.search){
        if(this.filters.search[name]==='' || typeof this.filters.search[name]==='object'){
          continue;
        }
        let searchParam = this.filters.search[name]
        searches[name] = typeof searchParam === 'string' ? searchParam.trim() : searchParam
      }
      if(this.toExcel==true ){
        if(this.options.selection.length){
          let ids = this.getProValues(this.options.selection)
          searches['ids'] = ids.join(',')
        }

        let cols = []
        let colsName = ['faRenCountry','faRenCertType','industryType','businessType','chanQuanRenCertType','chanQuanRenCountry','jingYinRenCertType','jingYinRenCountry','rentType','realCertType','realCountry','certType','nation','country','personWorkType','yuDingRenCertType','yuDingRenCountry','chanQuanRenNation','certificateCodeType','education','level','isAlarm','department','sex','marriage','openType']
        let colsCode = ['policeStaCode','provinceCode','cityCode','areaCode']
        let prop = ''
        if(this.tableVarity && this.tableColumn){
          this.tableColumn.map((item)=>{
            prop = item.property || item.prop
            if(colsName.indexOf(prop)>-1){
              prop = prop+'Name'
            }else if(colsCode.indexOf(prop)>-1){
              prop = prop.replace('Code','Name')
            }
            item.visible && cols.push(prop)
          })
        }
        searches['exportFiled'] = cols.join(',')
      }
      if(this.privatePagination){
        return {
          ...searches,
          pageNumber: this.privatePagination.pageIndex,
          pageSize: this.privatePagination.pageSize,
          toExcel:this.toExcel
        }
      }else{
        return {
          ...searches,
          pageNumber: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
          toExcel:this.toExcel
        }
      }
    },
    encryptColData(colData,iKey){
      if(colData===null || colData==''){
        return '--'
      }
      if(!this.tableEncryption){
        return colData
      }
      let encryptCols1 = ['openPeople']
      let encryptCols2 = ['identification']
      let encryptCols3 = ['certificateCode']
      let retVal = ''
      let star = ''
      if(encryptCols1.indexOf(iKey)>-1){
        for (let  i = 0; i < colData.length-2; i++) {
          star= star + '*'
        }
        retVal = colData.substr(0,1)+star
      }
      if(encryptCols2.indexOf(iKey)>-1){
        retVal = colData.substr(0,3)+'****'+colData.substr(7,4)
      }
      if(encryptCols3.indexOf(iKey)>-1){
        retVal = colData.substr(0,6)+'********'+colData.substr(14,8)
      }
      return retVal
    },
    /**
     * 隐私数据加密
     */
    toggleSecret(){
      this.tableEncryption = !this.tableEncryption

    },

    /**
     * 表头输入查询
     * @param {row数据对象} h
     * @param {列对象，序号} {column, $index}
     */
    renderHeaderInputFun(row, { column, $index }) {
      return (
        <el-input
          clearable
          placeholder={column.label}
          value={this.filters.search[column.labelClassName || column.property]}
          on-input={(val) => {
            let props = column.labelClassName || column.property;
            //避免IE11在初始赋值时也会调用search()
            if (this.filters.search[props] !== '' && val === '') {
              this.filters.search[props] = '';
              this.handleSearch();
            } else {
              this.filters.search[props] = val ? val : '';
            }
          }}
          nativeOn-keyup={(event, val) => {
            if (event.keyCode === 13) {
              this.handleSearch();
            }
          }}></el-input>)
    },
    /**
     * 表头下拉框查询
     * @param {row数据对象} h
     * @param {列对象，序号} {column, $index}
     * @param {数组对象} options
     */
    renderHeaderSelFun(h, { column, $index }, options,isDict=1) {
      let tempResult = []
      if(isDict==1){
        options && options.forEach(obj => {
          tempResult.push(
          < el-option
          key={'dd_' + obj.name}
          label={obj.value}
          value={obj.name} />
        )
        });
      }else if(isDict==2){
        options && options.forEach(obj => {
          tempResult.push(
          < el-option
          key={'dd_' + obj.value}
          label={obj.text}
          value={obj.value} />
        )
        });
      }else if(isDict==3){
        options && options.forEach(obj => {
          tempResult.push(
          < el-option
          key={'dd_' + obj.label}
          label={obj.value}
          value={obj.label} />
        )
        });
      }

      return (
        < el-select
          clearable
          filterable
          class="column-header"
          placeholder={column.label}
          value={this.filters.search[column.labelClassName || column.property]
          }
          on-change={(val) => {
            let props = column.labelClassName || column.property;
            this.filters.search[props] = val ? val : '';
            this.filtersSet(column, val)
            this.handleSearch();
          }
          }
        >
          {
            tempResult
          }
        </el-select>
      )
    },
    filtersSet(column, val) {

    },
    /**
     * 数字转整数 如 100000 转为10万
     * @param {需要转化的数} num
     * @param {需要保留的小数位数} point
     */
    tranNumber(num, point) {
      var num = parseFloat(num);
      if (num < 10000) {
        return num
      } else {
        num = (num / 10000).toFixed(point)
        return num
      }
    },
    /**
     * 表格列表选择更新后
     * @param {表格已经选择的list} val
     */
    selectionChangeHandle(val) {

    },
    /**
     * 表格列表被选中的行切换后
     * @param {表格列表选中的行} row
     */
    handleCurrentChange(row) {

    },
    /**
     * 表格列表行点击处理
     */
    handleRowClick(row, event, column) {
      if (this.$refs[this.tableVarity]) {
        this.$refs[this.tableVarity].$refs['table'].toggleRowSelection(row)
      }
    },
    /**
     * 获取对象数组中某个属性值
     * @param {数组} list
     * @param {键值} name
     * @return {返回数组} ret
     */
    getProValues(list, name = 'id') {
      let ret = []
      list && list.map((item) => {
        ret.push(item[name])
      })
      return ret
    },
    /**
     * 获取对象数组中某个属性值
     * @param {类型} dictType
     * @return {返回数组} data
     */
    async getDctList(dictType) {
      let url = 'RESOURCE.GET_MULTI_LIST';
      let params = {
        type: dictType,
        start: 0,
        size: 500,
        toExcel: false
      };
      let res = await this.fetchData({
        url,
        method: 'get',
        params
      })

      let retData = (res && res.data) ? res.data : []
      return retData
    },
    /**
     * 获取地址列表
     */
    async getAreaDict(areaCode, type) {
      let params = {
        areaCode: areaCode
      };
      let url;
      if (type === 'polices') {
        url = 'COMBOBOX.FIND_POLICE_STATION_LIST_BY_AREA_CODE'
      } else {
        url = 'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE';
      }
      let res = await this.fetchData({
        url,
        method: 'get',
        params
      })
      let retData = (res && res.data) ? res.data : []
      return retData
    },

    //批量删除
    handlePatchDelete(isParams=false, method = 'post', cb) {
      let ids = this.getProValues(this.options.selection)
      if (!ids.length) {
        this.$message({ type: 'info', message: '请选择数据！' })
        return
      }
      let tipStr = '确定删除当前选中的（' + ids.length + '条记录）信息吗？'
      this.$confirm(tipStr, { type: 'warning' }).then(() => {

        this.fetchData({ url: this.deleteUrl,headers: { "Content-Type": "application/json" }, method, params: ids, timeout: 0, isLoading: false, flag: true }).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.msg || '操作成功！')
            this.getDataList()

            cb && cb()
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        }).catch((err) => {
          console.log(err, 'delete err')
        })
      }).catch(() => false)
    },
    //导出
    exportData() {
      let selCount = this.options.selection.length
      let tipStr = '确定导出所有信息吗？'
      if (selCount) {
        tipStr = '确定导出当前选中的（' + selCount + '条记录）信息吗？'
      }

      this.$confirm(tipStr, { type: 'warning' }).then(() => {
        this.toExcel = true
        this.getQuery()
      }).catch(() => false)
    },

    //处理null
    drawDataList(dataList){
      if(!dataList || dataList.length==0){
        return []
      }
      dataList.map((item)=>{
        for(let key in item){
          if(item[key]===null){
            item[key] = ''
          }
        }
      })
      return dataList
    }
  }
}
